import React from 'react'

const StatisticPage = () => {
  return (
    <div>StatisticPage</div>
  )
}

export default StatisticPage